import LettersReportsReducer from "./LettersReportsReducer";
import modalReducer from "./modalReducer";
import DashboardReducer from "./DashboardReducer";
import ContactReducer from "./ContactReducer";
import UserReducer from "./UserReducer";
import PersonalDetailsReducer from "./PersonalDetailsReducer";
import { combineReducers } from "redux";

// IMPORTANT! when adding new reducer, you need to add in the configStore file the reducer to black/white persist state list.
const rootReducer = combineReducers({
  UserReducer,
  LettersReportsReducer,
  modalReducer,
  DashboardReducer,
  PersonalDetailsReducer,
  ContactReducer
});

export default rootReducer;
